import React, { useState } from 'react';
import noop from 'lodash/noop';

import useGroupForm from '../state/useGroupForm';
import Button from 'ui/Button';
import Input from '../components/Input';
import Spinner from '../../../ecoui/UISpinner';
import { deadlineDropdownOptions } from '../utils';
import DeadlineSelectionPopup from 'features/SpilKlub/components/DeadlineSelectionPopup';
import Checkbox from './Checkbox';

const GroupForm = ({
    onSuccess,
    balance,
    defaults = {},
    groupId,
    selections,
    combinationPrice,
    combinationCount,
    poolMode,
    onError,
    uiActions,
    changeName = () => {},
}) => {
    const isNewGroup = groupId === null;

    const { setter, values, save, status, errors, hasErrors } = useGroupForm({
        defaults,
        selections: poolMode ? selections : [],
        combinationPrice,
        combinationCount,
        onSuccess,
        groupId,
        onError,
    });

    const [formTouched, setFormTouched] = useState(false);
    const showFormErrors = () => setFormTouched(true);

    const [openDeadlineSelection, setOpenDeadlineSelection] = useState(false);

    const inputProps = {
        setter,
        values,
        errors,
        showFormErrors,
        showErrors: formTouched,
    };

    const sharePriceValue = values.sharePrice.get();
    const shareNumberValue = values.shareNumber.get();

    const handleModalOpen = () => {
        if (shareNumberValue !== 0 && Number(sharePriceValue) > balance) {
            uiActions.showModal('LOW_BALANCE');
        }
    };

    const handleSaveAndCheckBalance = () => {
        if (hasErrors) {
            return noop();
        }
        handleModalOpen();
        save();
    };
    const { isLoading } = status;

    return (
        <>
            {/* Club name */}
            <Input
                {...inputProps}
                name="name"
                label="Klubnavn"
                placeholder="Skriv Klubnavn..."
                disabled={!!groupId}
                locked={!!groupId}
                onChangeValue={(value) => changeName(value)}
            />

            {/* Deadline for bet */}
            <Input
                {...inputProps}
                type="customSelect"
                name="deadline"
                label="Deadline for køb"
                placeholder="Deadline for køb"
                callback={() => setOpenDeadlineSelection(true)}
                options={deadlineDropdownOptions}
                dropdown={
                    <DeadlineSelectionPopup
                        title={'Deadline for køb'}
                        value={values['deadline'].get()}
                        isOpen={openDeadlineSelection}
                        onClose={() => setOpenDeadlineSelection(false)}
                        options={deadlineDropdownOptions}
                        onChange={(value) => setter({ ['deadline']: value })}
                    />
                }
            />

            <div className="flex space-between">
                {/* Share price */}
                <div className="flex-grow right-indent-sm">
                    <Input
                        {...inputProps}
                        name="sharePrice"
                        label="Pris pr. andel"
                        suffix=" kr."
                    />
                </div>
                {/* Max shares */}
                <div className="flex-grow">
                    <Input
                        {...inputProps}
                        name="maxShares"
                        label="Maks antal andele"
                        suffix=" stk."
                    />
                </div>
            </div>

            {/* Number of shares */}
            <Input
                {...inputProps}
                name="shareNumber"
                label="Dine antal andele"
                placeholder="Dine antal andele"
                type="counter"
            />

            {/* Public group */}
            {isNewGroup && (
                <Checkbox
                    label="Gør din klub offentlig?"
                    value={values.isPublic.get()}
                    onChange={(value) => {
                        showFormErrors();
                        setter({ isPublic: value });
                    }}
                />
            )}

            <Button
                onClick={handleSaveAndCheckBalance}
                active
                className={'full-width'}
                margin="40px 0 0 0"
                style={{ opacity: hasErrors ? '0.7' : '1' }}
            >
                {isLoading ? <Spinner plain /> : 'Fortsæt'}
            </Button>
        </>
    );
};

export default GroupForm;
